module.exports = __webpack_public_path__ + "static/media/label.3ca0ac14.png";